import React from 'react'
import ProjectComponents from '../ProjectComponents';

export const React_Redux_Cart = () => {
    return (
        <ProjectComponents
            imgSrc={
                "https://user-images.githubusercontent.com/97354310/181919684-c7756e66-5589-40fe-8024-7b2cf717032d.png"
            }
            originalLink={ "#" }
            title={ "React-Redux Cart" }
            about={
                "This is a simple cart functionality mini project. This project is build on using React, Redux, and Chakra Ui or this mini web is fully responsive for all types of devices, so anyone can see product details on any type of screen size devices. "
            }
            blogLink={
                "#"
            }
            gitLink={ "https://github.com/Akshay-Singh-Rajput/React_Redux_Cart" }
            demoLink={ "https://ak-redux-cart.netlify.app//" }
            videoLink={ "https://youtu.be/T_HFj3oWIk0" }
        />
    );
}
